import React, { Suspense } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "apollo-react/components/Loader";
import NavigationBar from "apollo-react/components/NavigationBar";
import Typography from "apollo-react/components/Typography";
import Button from "apollo-react/components/Button";
import Refresh from "apollo-react-icons/Refresh";
import Footer from "../Layout/index";
import { useResponsiveDesign } from "../hooks/useResponsiveDesign";

const SystemUnavailable = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet } = useResponsiveDesign();

  const handleLogoClick = () => {
    navigate("/");
  };

  const handleRetry = () => {
    // Reload the current page to retry
    window.location.reload();
  };

  // ResponsiveLogo component
  const ResponsiveLogo = () => (
    <Typography
      style={{
        color: "white",
        lineHeight: "56px",
        marginRight: isMobile ? "8px" : "24px",
        cursor: "pointer",
        zIndex: 2,
        whiteSpace: "nowrap",
        fontSize: isMobile ? "14px" : isTablet ? "16px" : "18px",
      }}
      onClick={handleLogoClick}
    >
      {isMobile ? (
        <>
          IQVIA <span style={{ fontWeight: 600 }}>CDSG</span>
        </>
      ) : (
        <>
          IQVIA <span style={{ fontWeight: 600 }}>Connected Devices Site Gateway</span>
        </>
      )}
    </Typography>
  );

  return (
    <>
      {/* Header Navigation */}
      <NavigationBar
        LogoComponent={ResponsiveLogo}
        maxWidth="100%"
        waveVariant="both"
        variant="brand"
        truncate={isMobile || isTablet}
        groupingButtonLabel="Menu"
        showMenuIcon={isMobile}
        style={{
          pointerEvents: "auto",
          minHeight: isMobile ? "48px" : "56px",
        }}
      />

      <div
        style={{
          display: "flex",
          height: "calc(100vh - 56px)",
          position: "relative",
          marginTop: "56px",
          flexDirection: "column",
        }}
      >
        {/* Main Content Area */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            transition: "margin-left 0.3s ease",
            overflow: "hidden",
          }}
        >
          {/* Content wrapper */}
          <div
            style={{
              flex: 1,
              overflow: "hidden",
              padding: "0.5rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Suspense fallback={<Loader overlayClassName="fallback-loader" />}>
              <div
                style={{
                  position: "relative",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* System Unavailable Header - Top Left */}
                <div
                  style={{
                    position: "absolute",
                    top: "0.5rem",
                    left: "0.5rem",
                    zIndex: 1,
                  }}
                >
                  <Typography
                    variant="h4"
                    className="bold-large-text"
                    style={{ fontSize: isMobile ? "18px" : "24px" }}
                  >
                    System Unavailable
                  </Typography>
                </div>

                {/* Main Content - Centered */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: 1,
                    padding: isMobile ? "1rem" : "1.5rem",
                    textAlign: "center",
                    paddingTop: isMobile ? "3rem" : "4rem", // Account for header
                  }}
                >
                  {/* System Unavailable Illustration */}
                  <div style={{ marginBottom: isMobile ? "1rem" : "1.5rem" }}>
                    <img
                      src="/systemUnavailable.png"
                      alt="System unavailable illustration"
                      style={{
                        maxWidth: isMobile
                          ? "200px"
                          : isTablet
                          ? "250px"
                          : "300px",
                        width: "100%",
                        height: "auto",
                        maxHeight: isMobile ? "150px" : "200px",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Text Content */}
                  <div
                    style={{
                      marginBottom: isMobile ? "1rem" : "1.5rem",
                      maxWidth: isMobile ? "280px" : "500px",
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{
                        marginBottom: "0.5rem",
                        color: "#666",
                        fontSize: isMobile ? "13px" : "15px",
                        lineHeight: "1.4",
                      }}
                    >
                      We're experiencing a temporary issue and working to
                      restore things quickly.
                    </Typography>
                    <Typography
                      style={{
                        color: "#666",
                        fontSize: isMobile ? "12px" : "14px",
                        lineHeight: "1.4",
                      }}
                    >
                      Please try again in a few moments.
                    </Typography>
                  </div>

                  {/* Retry Button */}
                  <div>
                    <Button
                      variant="secondary"
                      size="small"
                      icon={<Refresh />}
                      iconPosition="start"
                      onClick={handleRetry}
                      style={{
                        minWidth: isMobile ? "100px" : "120px",
                        padding: isMobile ? "8px 16px" : "10px 20px",
                      }}
                    >
                      Retry
                    </Button>
                  </div>
                </div>
              </div>
            </Suspense>
          </div>

          {/* Footer - Compact */}
          <div style={{ flexShrink: 0 }}>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default SystemUnavailable;
